import { Handler } from "../interfaces/Handler.interface";
import { Store } from "../interfaces/Store.interface";
import { getValue } from "./getValue";

interface WatchConfig {
    store?: Store,
    once?: boolean
}

/**
 * [Impure] Add function to listeners to run when value is set.
 * @param handler - Handler object.
 * @param key - Key to watch in store.
 * @param fn - Function to run when store[key] is updated.
 * @param config - Optional configuration object.
 */
export function watch(handler: Handler, key: string, fn: Function | any, config: WatchConfig = {}) {
    // Initialize variables.
    const { once, store } = config;

    // Backfill value if given store.
    if(store){
        let value = getValue(key, store);                                       // Get value from store.
        if (value === undefined) value = getValue("preset", store, {})[key];    // Try to get value from preset if store is empty.
        if (value !== undefined) fn(value);                                     // If value exists, run function with value.
        if (value !== undefined && once) return;                                // If once option is true, exit here without adding fn to listeners.
    }

    // Push listener to handler.
    handler[key] = (handler[key] || []).concat(fn);                                         // Push function to listener array (create array if none exists).
    if(once) handler[key].push(() => handler[key] = handler[key].filter(e => e !== fn));    // Add another listener to remove original function after it runs. 
}
